import { CreditLineProvider, EnumSchema, FromSchema, ZodObjectId } from '@40seas/entities/common';
import { Fee, FeeSchema, PaymentTermTiming, PaymentTermType } from '@40seas/models';
import { z } from 'zod';
import { PaymentMethodType } from './payment-method-type.enum';

export const PaymentTermsOptionSchema = z
    .object({
        days: z.number(),
        countFrom: EnumSchema(PaymentTermTiming),
        provider: EnumSchema(CreditLineProvider).optional(),
        paymentMethods: z.array(EnumSchema(PaymentMethodType)),
        feeDefinition: ZodObjectId.optional(),
        buyerFee: FeeSchema.nullish(),
        supplierFee: FeeSchema.nullish(),
    })
    .strict();

export class PaymentTermsOption extends FromSchema(PaymentTermsOptionSchema) {
    days?: number;
    countFrom?: PaymentTermTiming;
    provider?: CreditLineProvider;
    paymentMethods?: PaymentMethodType[];
    feeDefinition?: string;
    buyerFee?: Fee;
    supplierFee?: Fee;
}

export type PaymentTermsOptions = {
    [key in PaymentTermType]?: PaymentTermsOption[];
};

export const PaymentTermsOptionsDtoSchema = z.record(EnumSchema(PaymentTermType).optional(), z.array(PaymentTermsOptionSchema));

export class PaymentTermsOptionsDto {
    [key: string]: PaymentTermsOption[];
}
